import { useEffect, useState } from "react";
import { navLinks, brandName, brandSlogan } from "@/mocks/guaContent";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const ids = [...navLinks.map((l) => l.id), "top"];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: "-40% 0px -55% 0px" }
    );
    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  const transparent = !scrolled;

  return (
    <header
      className={
        "fixed top-0 inset-x-0 z-50 transition-all duration-300 " +
        (transparent ? "bg-transparent py-4" : "bg-background-50/95 backdrop-blur border-b border-background-200 py-2")
      }
    >
      <nav className="px-4 md:px-8 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 group">
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-white text-lg">
            <i className="ri-newspaper-fill"></i>
          </span>
          <span className="flex flex-col leading-tight">
            <span
              className={
                "font-heading text-lg font-bold " +
                (transparent ? "text-white" : "text-foreground-900")
              }
            >
              {brandName}
            </span>
            <span
              className={
                "text-[11px] tracking-wide " +
                (transparent ? "text-white/80" : "text-foreground-500")
              }
            >
              {brandSlogan}
            </span>
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-1">
          {navLinks.map((l) => (
            <li key={l.id}>
              <a
                href={`#${l.id}`}
                className={
                  "px-3 py-2 text-sm rounded-md transition " +
                  (transparent
                    ? "text-white/90 hover:text-white hover:bg-white/10"
                    : "text-foreground-700 hover:text-primary-600 hover:bg-primary-50") +
                  (active === l.id ? (transparent ? " bg-white/15 text-white" : " bg-primary-50 text-primary-700") : "")
                }
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-2">
          <a
            href="#plans"
            className="whitespace-nowrap rounded-md bg-primary-500 text-white text-sm font-semibold px-5 py-2.5 hover:bg-primary-600 transition"
          >
            订阅瓜报
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className={
            "lg:hidden w-10 h-10 flex items-center justify-center rounded-md " +
            (transparent ? "text-white hover:bg-white/10" : "text-foreground-800 hover:bg-background-100")
          }
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-3 md:hidden">
          <ul className="flex flex-col">
            {navLinks.map((l) => (
              <li key={l.id}>
                <a
                  href={`#${l.id}`}
                  onClick={() => setOpen(false)}
                  className="block px-2 py-3 text-sm text-foreground-800 hover:text-primary-600 border-b border-background-100"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#plans"
            onClick={() => setOpen(false)}
            className="mt-3 block text-center whitespace-nowrap rounded-md bg-primary-500 text-white text-sm font-semibold px-5 py-3 hover:bg-primary-600 transition"
          >
            订阅瓜报
          </a>
        </div>
      )}
    </header>
  );
}